export const NavChevron = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <g opacity="0.5">
      <path
        d="M6 7.5L9 10.5L12 7.5"
        stroke="currentColor"
        strokeLinecap="square"
      />
    </g>
  </svg>
);
